module.exports = __webpack_public_path__ + "static/img/image01.e4e5e44.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sm/landingPage/image01.png
// module id = dE3Z
// module chunks = 0